import { Dynamic } from "./dynamic.js";
import { FullHeightContainer } from "./FullHeighContainer.js";
import { PageTitle, PageTitleProps } from "./pageTitle.js";
import { Validator } from "./validator.js";
import { Menu } from "./menu.js";
import { RightDrawerContainer } from "./rightDrawerContainer.js";
import { Helper } from "../util/helper.js";
import { EntityReminders } from "../../reminders/reminders.js";
import { BookmarkBtn } from "../../bookmark/bookmarkBtn.js";
import { Sheet } from "../../../siteManagement/sheet.js";
import { General } from "../../../siteManagement/general.js";
import { ApplicationTabStrip } from "./applicationTabstrip.js";
import { AppHelper } from "../../appHelper.js";
import { MonacoJsonEditor } from "./monacoEditor.js"
import { RSplitter } from "./rSplitter.js";
import { MetadataTab } from "./tabStrip.js";
import { CommandManagerAPI, StringKeyDictionary } from "../../commonInterfaces.js";
import React from "react"

export class CommonApp extends React.Component<CommonAppProps, any>{
    private hasValue = Helper.hasValue;
    private sheet: Sheet;

    constructor(props: CommonAppProps) {
        super(props);
        this.sheet = General.Sheet.Manager.getTopMostSheet();
    }

    render() {

        const apphelper: AppHelper = this.props.apphelper;

        const titleProps: PageTitleProps = {
            title: this.props.sheetTitle,
            value: null,
            locked: null,
            lockInfo: null,
            followed: false
        };

        if (!this.props.entity.IsNew && this.hasValue(this.props.titleProps)) {
            titleProps.value = this.props.titleProps.value;
            titleProps.locked = this.props.titleProps.locked;
            titleProps.lockInfo = this.props.titleProps.lockInfo;
            titleProps.followed = this.props.entity.IsWatched;
        }
        let content =
            <Validator onCreateValidator={this.props.handleCreateValidator}>
                <ApplicationTabStrip
                    metadata={this.props.metadata}
                    entity={this.props.entity}
                    dataSources={this.props.dataSources}
                    context={this.props.context}
                    horizontal={this.props.horizontalTabStrip}
                    onChange={this.props.handleFieldChange}
                    onDataLoaded={this.props.handleDataLoaded}
                    onTabChange={(metadataTab) => {
                        if (Helper.hasValue(this.props.onTabChange))
                            this.props.onTabChange(metadataTab.iskey);
                        if (metadataTab?.helpUrl != null)
                            this.setState({ helpUrl: metadataTab.helpUrl });
                    }}
                    handleEval={this.props.handleEval}
                    handleIsSearchFieldFullObjectModel={this.props.handleIsSearchFieldFullObjectModel}
                    handleIndividulFieldsMetaDataCreated={this.props.handleIndividulFieldsMetaDataCreated}
                    translations={this.props.translations}
                    commandManager={this.props.commandManager}
                    actionCallbacks={this.props.actionCallbacks}
                    sheet={this.sheet}
                    apphelper={apphelper}
                    resolveModule={apphelper ? apphelper.resolveModule : null}
                    debug={this.props.debug}
                />
            </Validator>;
        let contentWithSplitter = (this.props.dc4Splitter != null) ?
            (<RSplitter direction={this.props.dc4Splitter.direction} initialPercentage={this.props.dc4Splitter.initialPercentage} rememberPercentage={this.props.dc4Splitter.rememberPercentage} id={`commonContent_${this.props.context.contextType}`}>
                <Dynamic {...this.props} customProps={this.props.dc4Props} componentName={this.props.dc4ComponentFunc} moduleName={this.props.dc4ModuleName} appName={this.props.dc4AppName} />
                {content}
            </RSplitter>) :
            (<>
                <Dynamic {...this.props} customProps={this.props.dc4Props} componentName={this.props.dc4ComponentFunc} moduleName={this.props.dc4ModuleName} appName={this.props.dc4AppName} />
                {content}</>
            );
        const rightDrawerContainer = this.props.rightDrawerContainer == null ? null
            : <RightDrawerContainer {...this.props} customProps={this.props.rightDrawerContainer ? this.props.rightDrawerContainer.props : null}
                helpUrl={this.state?.helpUrl}
                moduleName={this.props.rightDrawerContainer ? this.props.rightDrawerContainer.moduleName : null} appName={this.props.rightDrawerContainer ? this.props.rightDrawerContainer.appName : null}
                visible={this.props.rightDrawerContainer ? this.props.rightDrawerContainer.visible : false}
                width={this.props.rightDrawerContainer ? this.props.rightDrawerContainer.width : 0}
                multipleComponents={this.props.rightDrawerContainer.multipleComponents}
                renderAlways={this.props.rightDrawerContainer.renderAlways} />;
        return (
            <FullHeightContainer context={this.props.context.contextType}>
                <PageTitle {...titleProps} />
                <FullHeightContainer>
                    <Dynamic {...this.props} customProps={this.props.dc1Props} componentName={this.props.dc1ComponentFunc} moduleName={this.props.dc1ModuleName} appName={this.props.dc1AppName} />
                    <Dynamic {...this.props} customProps={this.props.dc2Props} componentName={this.props.dc2ComponentFunc} moduleName={this.props.dc2ModuleName} appName={this.props.dc2AppName} />
                    <Dynamic {...this.props} customProps={this.props.dc3Props} componentName={this.props.dc3ComponentFunc} moduleName={this.props.dc3ModuleName} appName={this.props.dc3AppName} />
                    <FullHeightContainer classes={this.props.formContainerClass || ""}>
                        {contentWithSplitter}
                    </FullHeightContainer>
                    <Dynamic {...this.props} customProps={this.props.dc5Props} componentName={this.props.dc5ComponentFunc} moduleName={this.props.dc5ModuleName} appName={this.props.dc5AppName} />
                </FullHeightContainer>
                <Menu
                    entries={this.props.menuEntries}
                    onSelect={this.props.handleMenuSelect}
                    enableMenuItem={this.props.enableMenuItem}
                    handleEval={this.props.handleEval}
                    sheet={this.sheet}
                    loadedModules={apphelper ? apphelper.getLoadedModules() : null}
                    debug={this.props.debug}
                />
                {rightDrawerContainer}
                {this.props.showContextReminders ? <EntityReminders /> : null}
                {this.props.showBookmarkBtn ? <BookmarkBtn contextType={this.props.context.contextType} additionalData={{ entity: this.props.entity }} /> : null}

            </FullHeightContainer>
        );
    }
}

export class Editor extends React.Component<any, any>{
    render() {
        return <MonacoJsonEditor entity={this.props.parent.entity} onChangeMetadata={this.props.parent.onChangeMetadata} metadataType={this.props.parent.metadataType} />
    }
}

export interface CommonAppBaseProps extends React.PropsWithChildren {
    onChange(field: { model: string }, value: any, dataItem?: any);
    entity: Entity;
    context?: Context;
    handleEval?(expression: string, additional?: any);
    handleIsSearchFieldFullObjectModel?(field: { model: string }, object: any);
    onDataLoaded?(field: { model: string }, data: any);
    commandManager?: CommandManagerAPI;
    actionCallbacks?: StringKeyDictionary<any>;
}

export interface CommonAppProps extends CommonAppBaseProps {
    metadata: Metadata;
    title?: string;
    isWindow: boolean;
    handleMenuSelect(action: string);
    enableMenuItem(action: string);
    handleCreateValidator(validator: kendo.ui.Validator);
    dataSources?: {};
    handleFieldChange(field: { model: string }, value: any, dataItem?: any);
    handleDataLoaded(field: { model: string }, data: any);
    handleIndividulFieldsMetaDataCreated?(metadata: any);
    translations?: any;
    dc4Splitter?: { direction: 0 | 1, initialPercentage: number, rememberPercentage: boolean };
    dc1ComponentFunc?: string | (() => JSX.Element);
    dc2ComponentFunc?: string | (() => JSX.Element);
    dc3ComponentFunc?: string | (() => JSX.Element);
    dc4ComponentFunc?: string | (() => JSX.Element);
    dc5ComponentFunc?: string | (() => JSX.Element);
    dc1ModuleName?: string;
    dc2ModuleName?: string;
    dc3ModuleName?: string;
    dc4ModuleName?: string;
    dc5ModuleName?: string;
    dc1AppName?: string;
    dc2AppName?: string;
    dc3AppName?: string;
    dc4AppName?: string;
    dc5AppName?: string;
    dc1Props?: {};
    dc2Props?: {};
    dc3Props?: {};
    dc4Props?: {};
    dc5Props?: {};
    formContainerClass?: string;
    horizontalTabStrip?: boolean;
    rightDrawerContainer?: { moduleName: string, appName?: string, visible: boolean, width: number, drawerStyle: number, props: any, multipleComponents?: Array<{}>, renderAlways?: boolean };
    titleProps?: PageTitleProps;
    onTabChange?(tabKey: string): void;
    menuEntries?: any;
    sheetTitle?: string;
    showContextReminders?: boolean;
    showBookmarkBtn?: boolean;
    apphelper?: any;
    resolveModule?(moduleName: string): Saveable;
    loadedModules?: Saveable[];
    debug?: boolean;
}

export interface AppBaseProps {
    entity: Entity;
    metadata: Metadata;
    context: Context;
    dataSources: any;
    title?: string;
    isWindow: boolean;
    helpUrl?: string;
}

export interface Metadata {
    metaDataType?: string;
    tabs: Array<MetadataTab>;
    additional?: MetadataAdditional;
    browserTitle?: string;
    pageTitle?: string;
    rightDrawerContainer?: any;
    menuDataSource?: any;
    formatVersion?: number;
    hideMenu?: boolean
}

interface MetadataAdditional {
    objects: Array<MetadataAdditionalObject>;
}

interface MetadataAdditionalObject {
    name: string;
    model?: any;
    data?: any;
}

export interface Context {
    key1?: string;
    keyVal1?: any;
    key2?: string;
    keyVal2?: any;
    key3?: string;
    keyVal3?: any;
    contextType?: string;
}

export interface Saveable {
    Save();
    GetComponent(keyval1: string, keaVal2: string, props: any, recordRight: any): React.ReactNode;
    HasChanges(): boolean;
    GetMenuItem(onClick: any): React.Component;
}

export interface Entity {
    IsNew: boolean;
    RecordRight: {
        CanRead: boolean;
        CanWrite: boolean;
        CanWritePermissionDeniedReason?: string;
    }
    IndividualFields?: any;
    IsWatchable: boolean;
    IsWatched: boolean;
}

export interface BaseArticle extends Entity {
    Artikelnr?: number;
    Artikelnummer?: string;
    Bezeichnung?: string;
}

export interface AdditionalData {
    Description: string;
}